module.exports = __webpack_public_path__ + "static/media/security.fb170c9c.svg";